
import {SuperDebug} from '../../utils/debug/Sdebug';
let debug_session = SuperDebug('session', true);

import store from '../../store/store.js';
import {Navigator} from '../../router/Navigator';
import {PromiseErrorHandler} from "../../utils/Error";
import {Local_Storage,session_Storage} from "../../store/local.storage";
import {ServerBizApi, ServerProdApi,ServerProdApidl} from '../../../src/group-cloud/network/ServerBizApi';
import $globals from '../../h5_src/framework/Globals';
import {Menus} from "../../h5_src/framework/Menus";
import {Account} from "../../h5_src/framework/Account";
import {Message} from "element-ui";

let userState = {
    env: '',
    openId: '',
    name: '',
    avatar: '',
    pos: '',
    mobile: '',
    token: '',
    userId: 0
};
let userdata

export const Session = {
    nextLastPage: null,
    onNextSaveLastPage: false,
    userInfoLoaded: false,
    loginSuccess: async function(param, serverSession,flag) {
        // SimpleToastr.success('登录成功');
        // this.setServerSession(serverSession);
        this.setServerToken(serverSession);
        debug_session('login-success serverSession', serverSession);

        await this.syncGetRemoteUserInfo();
        // 设置默认跳转页面
        // let lastPage = Local_Storage.getLastPage() || { path: '/', query: {} };
        let lastPage =  { path: '/', query: {} };
        // debug_session('login-success last-page', lastPage);
        if(flag){
            return false
        }
        Navigator.replace(lastPage);
        // debug_session('login-success end');
    },
    getLastPage() {
        let lastPage = Local_Storage.getLastPage() || { path: '/', query: {} };
        return lastPage;
    },
    clearLoginStatus() {
        this.clearSession();
        localStorage.setItem('authorities','');
        sessionStorage.setItem('authorities','');
        localStorage.clear();
        Navigator.redirect('/pages/login', {});
    },
    logout: async function() {
        let url = 'tmp/logout';
        let callbacks = {
            success: (json) => {
                // this.clearSession();
                // Navigator.redirect('/login', {});
                this.clearLoginStatus();
            }
        };
        // let resp = await ServerBizApi.send(url, {});
        // if (resp && resp.succ) {
        //     this.clearLoginStatus();
        // }
        this.clearLoginStatus();
    },
    async authenticate(formDataasd) {

        // let url = 'auth_center/yooz/login/token';
        let url = 'token';
        let formdata = new FormData()

        formdata.append("verifyCode",formDataasd.Verification)
        formdata.append("password",formDataasd.password)
        formdata.append("username",formDataasd.username)
        formdata.append("type",formDataasd.type)
        formdata.append("tenantType",formDataasd.tenantType)
        // formData.grant_type     = 'password';
        // formData.remember_me    = '1';
        // formData.group_id    = '1';     // 1/2/3 分别代表 总部/客户/门店
        let response = await ServerProdApidl.send(url, formdata);
        console.log(response)
        if (response.result && response.result.token) {
            this.loginSuccess({}, response.result,false);
            userdata=response.result
            localStorage.setItem('authorities',JSON.stringify(userdata.authorities));
            sessionStorage.setItem('authorities',JSON.stringify(userdata.authorities));
        }



        return response;
    },
    async Switchcustomers(formDataasd) {

        // let url = 'auth_center/yooz/login/token';
        let url = 'switching/mechanism';
        let formesdata = {
            id:formDataasd.id,  // 这个是用户的id
            deptId:formDataasd.deptId  // 这个是用户需要切换的组织机构ID
        }
        let response = await ServerProdApidl.send(url, formesdata);
        if (response.result && response.result.token) {
            this.loginSuccess({}, response.result,true);
            userdata=response.result
            localStorage.setItem('authorities',JSON.stringify(userdata.authorities));
        }
        // console.log('authenticate-resp', response);

        return response;
    },
    // axios 拦截器 判断 502 错误码（Need login）时调用 此接口
    setExpired: function(code) {
        let codeMap = {
            501: '请登录',
            502: '没有权限',
        };
        let msg = codeMap[code] || '权限错误';
        // 不用在前端提示错误，后端会判断登录和权限，并通过 error 提示错误
        $globals.$vm.$notifyError(msg);
        if (501 === code) {
            // this.clearSession();     // 只清理，不跳转去登录
            this.clearLoginStatus();    // 清理后，跳转去登录
        }
    },
    // 清空登录凭证时也要保证 vuex 和 Local_Storage 同时被清空
    clearSession: function(obj = null) {
        userState.userId        = 0;
        userState.openId        = '';
        userState.name          = '';
        userState.pos           = '';
        userState.avatar        = '';
        userState.mobile        = '';
        userState.token         = '';
        if (obj && undefined !== obj.env) {
            userState.env = obj.env;
        }
        store.dispatch('session/sync', userState).catch(PromiseErrorHandler);
        store.dispatch('menu/clear').catch(PromiseErrorHandler);
        Local_Storage.setSession(userState);
    },
    // 登录成功，设置 token
    setServerToken: function(serverSession) {
        // console.log(['setServerToken', serverSession.token]);
        if (serverSession && serverSession.token && serverSession.token.length) {
            userState.token = serverSession.token;
        }
        store.dispatch('session/sync', userState).catch(PromiseErrorHandler);
        Local_Storage.setSession(userState);
        session_Storage.setSession(userState);
    },
    // 登录成功，同时设置 vuex 和 Local_Storage 双份登录凭证
    setServerSession: function(serverSession) {
        let savedSession = Local_Storage.getSession();
        // debug_session('setServerSession-savedSession-token', savedSession.token);
        // debug_session('setServerSession', serverSession);
        serverSession           = Account.translate(serverSession);
        userState.userId        = serverSession.user_id;
        userState.openId        = serverSession.open_id || '';
        userState.name          = serverSession.realname;
        userState.avatar        = serverSession.avatar;
        userState.mobile        = serverSession.phone;
        userState.pos           = serverSession.pos;
        userState.token         = savedSession.token || '';
        if (serverSession && undefined !== serverSession.env) {
            userState.env = serverSession.env;
        }
        store.dispatch('session/sync', userState).catch(PromiseErrorHandler);
        store.dispatch('menu/update').catch(PromiseErrorHandler);
        session_Storage.setSession(userState);
    },
    getSessionVariables() {
        return userState;
    },
    checkAutoLogin(from, to) {
        if (this.getUserId() > 0) { return false; }
        if (to.query.auto_login === '1') {   // 服务器端会修改为 auto_login=0
            // 指明了要自动登录，那么当前网页就是要记录的
            // Local_Storage.setLastPage(to);
            Navigator.redirectWeixinAuth();
            return false;
        } else if (to.query.auto_login === '0' && to.query.open_id && to.query.open_id.length) {
            Local_Storage.setLastPage(to);
            this.checkQueryOpenId(to.query.open_id);
            return false;
        }
    },
    onRouteChange: function(from, to, access) {
        console.log(to.fullPath);
        // debug_session('onRouteChange %j, %j', from.path, to.path, from, to);
        // debug_session('onRouteChange %j', from);
        // record last route
        // debug_session('record-route-change: from [%s] [%j], to [%s] [%j]', from.fullPath, from.query, to.path, to.query);
        // debug_session('record-route-match: ', [to.fullPath === '/login', from.fullPath !== '/']);
        // debug_session('record-route-match2: ', [to, from]);
        if (this.onNextSaveLastPage) {
            this.onNextSaveLastPage = false;
            // debug_session('update-lastpage: [%j]', this.nextLastPage);
            Local_Storage.setLastPage(this.nextLastPage);
        } else if (to.fullPath.indexOf('/login') !== -1 && from.path !== '/') {
            // 目标页面是 login，但 from 不是 /，那就要记录 last-page
            // from 不能是 / 的理由是，在 /login 页面刷新网页时，route 的过程就是从 / 到 /login
            // 因此避免登录后又跳回 login，在这种情况下，就不要记录 last-page 了
            // debug_session('record-last: from [%s] [%j], to [%s] [%j]', from.fullPath, from.query, to.path, to.query);
            Local_Storage.setLastPage(from);
        }

        if (access && access.needLogin) {
            // debug_session('auth-need-login: [%j]', access);
            this.onNextSaveLastPage = true;
            this.nextLastPage = to;
        }

        // debug_session('onRouteChange - last');

        // 每次页面变化，或者有重要操作时，都要尝试去远程获取用户信息
        // 内部有缓存，页面不刷新时，用户信息保存在 vuex 的 session 对象中，后续页面切换直接使用 vuex session 对象
        // 当某个 remote 操作出现需要登录的错误提示时，清空 vuex session 和 localStorage，跳转到登录页

        // 异步查询用户信息，不阻塞页面渲染
        // return  this.getRemoteUserInfo();
        // 同步查询，在 router beforeEach 中用 then 方法进行阻塞渲染

        // 内部缓存，确保页面不刷新时，不会反复从服务器获取数据
        // debug_session('load user info %j', this.userInfoLoaded);

        // console.log(this.userInfoLoaded)
        if (this.userInfoLoaded) {
            return false;
        }else if(to.fullPath === '/pages/login'||to.fullPath === '/pages/recoverPassword'){
            return false;
        } else {
            // async function always return a promise
            let ret = this.syncGetRemoteUserInfo();
            // debug_session('session-on-route-last-ret', ret);
            this.userInfoLoaded = true;
            return ret;
        }

        // 重要的注释
        // 参考 PHP Session Lock 方面的机制，File/MemCached 等存储驱动，会有 Lock，
        // 在 Request-1 释放之前，Request-2 的 Session 由于得不到 Lock 会一直等待
        // 此时同步异步请求用户信息无所谓，因为服务器层面限制了顺序请求
        // 但使用 Redis 的 Session 存储，没有 Lock 机制，Req-1 和 Req-2 各自拿到 Session，在逻辑结束时写入
        // 在浏览器刷新页面时，为了避免浏览器的 LocalStorage 与 服务器的 userInfo 不一致，导致页面显示问题（*1）
        // 遂采取同步策略，强制在 router 层面，等待服务器更新了浏览器的 userInfo 后，再进行页面数据请求和渲染

        // 参考
        // *1：页面根据本地 LocalStorage 的 userInfo 来判断登录状态，然后渲染页面布局，在特定的时刻，比如 LocalStorage 中用户信息是已登录，
        // 但服务器中的登录信息已失效，会产生页面显示异常，比如 profile 页面，显示空头像，无昵称，还有退出按钮。

    },
    async checkQueryOpenId(open_id) {
        let url = 'staff-account/checkOpenId';   // 在这里检查是否已注册，未注册则创建新用户和默认群组等
        let data = {open_id: open_id};
        let response = await ServerBizApi.send(url, data);
        // debug_session('checkQueryOpenId response', response);
        if (response.result && response.result.token) {
            this.loginSuccess({}, response.result,false);
        }
    },
    async queryRoleMenuItems() {

        let url = 'menu/menu_list';
        let data = {};
        let response = await ServerProdApidl.send(url, data);
        // console.log(response)
        // response.result.push(list)
        // response.result.push(arr)
        // debug_session('getRoleMenuItems response', response);
        // if (response && response.items && response.items.length) {

          let arrs = response.result.childs
        if (response.code === 200 && arrs.length>0) {

            store.dispatch('menu/syncMenuItems', Menus.translate(arrs)).catch(PromiseErrorHandler);
            return  response;
        }else{
            return '无菜单权限，请联系管理员'
        }

    },

    // 同步请求
    async syncGetRemoteUserInfo() {
        // let userinfo = data.userinfo;
        // // let url = 'auth_center/yooz/auth/get_user_info';
        let url = 'user/get_user_info';
        // let obj = {
        //     username:userinfo.mobile,
        //     roleLists:userinfo.roleId
        // }
        let response = await ServerProdApidl.send(url,{});
        // debug_session('getRemoteUserInfo %j', response);
        console.log(response)
        if (response.result) {
            if (response.result.id) {
                // debug_session('getUserInfo-succ, write store and storage: %j', response);
                let res = await this.queryRoleMenuItems();
                if(res ==='无菜单权限，请联系管理员'){
                    $globals.$vm.$notifyError(res);
                    return false;
                }
                this.setServerSession(response.result);
                localStorage.setItem("userinfo",JSON.stringify(response.result))
            } else {
                // 不要强制跳转
                // debug_session('getUserInfo-fail, not logged in and credential is cleared: %j', response);
                this.clearSession();
            }
        }


        return  response;
    },
    getPos: function() {
        return  store.getters['session/userInfo'].pos;
    },
    getInfo: function() {
        // console.log();
        return  store.getters['session/userInfo'];
    },
    getAvatar: function() {
        return  store.getters['session/userInfo'].avatar;
    },
    getToken: function() {
        return  store.getters['session/userInfo'].token;
    },
    getMobile: function() {
        return  store.getters['session/userInfo'].mobile;
    },
    getName: function() {
        // return  store.getters['session/userInfo'].name;
        let name = store.getters['session/userInfo'].name;
        let arr = [];
        for (let idx = 0; idx < 1; idx++) {
            arr.push(name);
        }
        return arr.join(' .,,测试超长昵称什么的 ....。。。。，，，');
    },
    getUserId: function() {
        // return store.getters['session/userId'];

        // session 暂无数据时，尝试读取 localStorage，因为页面刷新后，获取用户登录信息是远程访问，需等待几秒能取到数据
        // 在此期间，session 会认为当前用户没有身份，导致跳转登录页
        // 而 localStorage 是客户端本地缓存，可以很好地避免这个问题
        // 远程信息获取后，session 和 localStorage 都会得到刷新，
        // 服务器端 session 过期后，会报异常错误码（need-login)，server-api 会强制刷新 session 接口让用户退出
        if (store.getters['session/userId'] > 0) {
            return  store.getters['session/userId'];
        } else {
            let _user = Local_Storage.getSession();
            if (_user && _user.userId) {
                return _user.userId;
            }
        }
        return  0;
    },
    isLoggedIn: function() {
        return this.getUserId() > 0;

    },
    replaceNonePhoneString(str) {
        return str.replace(/[^0-9]/gi, '');
    }
};

